module.exports = __webpack_public_path__ + "static/media/bg-img-slider1.0abfb51b.jpg";